import * as yup from "yup"

const loginFormSchema = yup.object({
  username: yup
    .string()
    .required("이메일을 입력해주세요.")
    .email("이메일 형식이 아닙니다."),
  password: yup
    .string()
    .required("비밀 번호를 입력해주세요.")
    .matches(
      /^(?=.*[a-z\d!@#$%^&*()])[^A-Z]{8,15}$/,
      "비밀번호는 8~15자의 영문 소문자, 숫자, 특수문자로 입력해주세요."
    ),
})

export default loginFormSchema
